















































import Vue from 'vue';
import negara from '@/const/country.json';
import { addDelegates } from '@/api/delegates';
// eslint-disable-next-line no-unused-vars
import { delegatesType } from '@/types/api';
import Autocomplete from '@/components/Autocomplete/index.vue';

export default Vue.extend({
  name: 'AddDelegates',
  components: {
    Autocomplete,
  },
  props: {
    items: Array,
  },
  data() {
    return {
      imageDel: null as null,
      newCountry: {
        name: '' as string,
        short: '' as string,
      },
      err: '' as string,
    };
  },
  // computed: {
  //   defImg() {
  //     return require('../../../../assets/img/home.png');
  //   },
  // },
  methods: {
    getDelegatesID(name: string): string {
      const data = negara.find((obj) => obj.name === name);
      if (data) return data['alpha-2'];
      return 'none';
    },
    exit(): void {
      this.$emit('exit');
    },
    onchangeCountry(country): void {
      this.err = '';
      this.newCountry.name = country;
    },
    async addNewCountry(): Promise<void> {
      try {
        if (this.newCountry.name.length > 0) {
          const data: delegatesType.addDelegates[] = [{
            country: this.newCountry.name,
            status: 'N/A',
          }];
          await addDelegates(this.$route.params.id, data);
          this.$emit('update');

          this.newCountry = {
            name: '',
            short: '',
          };
          this.$emit('exit');
        }
      } catch (err) {
        this.err = err.response.data.error.message;
        console.error(err.response);
      }
    },
  },
});
